import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";


export const estimatorTemplateApi = createApi({
    reducerPath: "estimatorTemplate",
    baseQuery: createCustomFetchBaseQuery(),
    tagTypes: ["estimatorTemplate"],
    endpoints: (builder) => ({
        getAllTemplates: builder.query({
            query: ({page , search ,role ,sortOrder="",sortBy ="", limit}) => {
                let url = `/${role}/estimator_templates?pageno=${page}&search=${search}&sortOrder=${sortOrder}&sortBy=${sortBy}`;
                if (limit) {
                    url += `&limit=${limit}`;
                }
                return {
                    url,
                    method: "GET",
                };
            },
            providesTags: ["estimatorTemplate"]
        }),
        updateTemplateStatus: builder.mutation({
            query: ({ id, data }) => ({
                url: `/estimator-templates/${id}`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["estimatorTemplate"]
        }),
        addPrimaryService: builder.mutation({
            query: ({ url, data }) => ({
                url,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["estimatorTemplate"]
        }),
        updatePrimaryService: builder.mutation({
            query: ({ url, data }) => ({
                url,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["estimatorTemplate"]
        }),
        deletePrimaryService: builder.mutation({
            query: ({ estimatorTemplateId, serviceId }) => ({
                url: `/contractor/estimator_template/${estimatorTemplateId}/service/${serviceId}`,
                method: "DELETE",
            }),
            invalidatesTags: ["estimatorTemplate"]
        }),
        restorePrimaryServices: builder.mutation({
            query: ({ estimatorTemplateId }) => ({
                url: `/contractor/estimator_template/${estimatorTemplateId}/service_restore`,
                method: "PUT",
            }),
            invalidatesTags: ["estimatorTemplate"]
        }),
        addAdditionalService: builder.mutation({
            query: ({ url, data }) => ({
                url,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["estimatorTemplate"]
        }),
        updateAdditionalService: builder.mutation({
            query: ({ url, data }) => ({
                url,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["estimatorTemplate"]
        }),
        deleteAdditionalService: builder.mutation({
            query: ({ url }) => ({
                url,
                method: "DELETE",
            }),
            invalidatesTags: ["estimatorTemplate"]
        }),
        restoreAdditionalServices: builder.mutation({
            query: ({ estimatorTemplateId }) => ({
                url: `/contractor/estimator_template/${estimatorTemplateId}/additional_service_restore`,
                method: "PUT",
            }),
            invalidatesTags: ["estimatorTemplate"]
        }),
        addTermsConditions: builder.mutation({
            query: ({ url, data }) => ({
                url,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["estimatorTemplate"]
        }),
        updateTermsConditions: builder.mutation({
            query: ({ url, data }) => ({
                url,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["estimatorTemplate"]
        }),
        deleteTermsConditions: builder.mutation({
            query: ({ url }) => ({
                url: `${url}`,
                method: "DELETE",
            }),
            invalidatesTags: ["estimatorTemplate"]
        }),
        restoreTermsConditions: builder.mutation({
            query: ({ estimatorTemplateId }) => ({
                url: `/contractor/estimator_template/${estimatorTemplateId}/term_restore`,
                method: "PUT",
            }),
            invalidatesTags: ["estimatorTemplate"]
        }),
        getEstimatorTemplateById: builder.query({
            query: ({ id }) => ({
                url: `/contractor/estimator_template?id=${id}`,
                method: "GET",
            }),
            providesTags: ["estimatorTemplate"]
        }),
        getAllEstimatorTemplateGeographicAdjusters: builder.query({
            query: () => ({
                url: `/contractor/estimator_template/geographic_adjuster`,
                method: "GET",
            }),
            providesTags: ["estimatorTemplate"]
        }),
        updateEstimatorTemplateGeographicAdjuster: builder.mutation({
            query: ({ id, geographic_adjuster_id, data }) => ({
                url: `/contractor/estimator_template/${id}/geographic_adjuster?geographic_adjuster_id=${geographic_adjuster_id}`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["estimatorTemplate"]
        }),
        updateEstimatorTemplateGeographicAdjusterToggle: builder.mutation({
            query: ({ id, data }) => ({
                url: `/contractor/estimator_template/${id}/geographic_adjuster_toggle`,
                method: "PATCH",
                body: data,
            }),
            invalidatesTags: ["estimatorTemplate"]
        }),
        updateEstimatorTemplateAdditionalDetails: builder.mutation({
            query: ({ id, data }) => ({
                url: `/contractor/estimator_template/${id}/additional_details`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["estimatorTemplate"]
        }),
        getSingleEstimatorTemplate: builder.query({
            query: () => ({
                url: `/contractor/estimator_template`,
                method: "GET",
            }),
            providesTags: ["estimatorTemplate"]
        }),
        restoreEstimatorTemplate: builder.mutation({
            query: ({ id }) => ({
                url: `/contractor/estimator_template/${id}/restore`,
                method: "PATCH",
            }),
            invalidatesTags: ["estimatorTemplate"]
        }),
        saveEstimatorTemplate: builder.mutation({
            query: ({ id, data }) => ({
                url: `/contractor/estimator_template/${id}/save`,
                method: "PATCH",
                body: data,
            }),
            invalidatesTags: ["estimatorTemplate"]
        }),
        deleteEstimatorTemplate: builder.mutation({ 
            query: ({ id }) => ({
                url: `/contractor/estimator_template/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["estimatorTemplate"]
        }),
        setDefaultGeographicAdjuster: builder.mutation({  
            query: ({ geographic_adjuster_id }) => ({
                url: `/contractor/estimator_template/${geographic_adjuster_id}/geographic_adjuster_default`,
                method: "PUT",
                body: { geographic_adjuster_id },
            }),
            invalidatesTags: ["estimatorTemplate"]
          }),
          getDefaultServices: builder.query({
            query: () => ({
                url: `/contractor/estimator_template/default_services`,
                method: "GET",
            }),
            providesTags: ["estimatorTemplate"]
          }),
          getDefaultAdditionalServices: builder.query({
            query: () => ({
                url: `/contractor/estimator_template/default_additional_services`,
                method: "GET",
            }),
            providesTags: ["estimatorTemplate"]
          }),
          getDefaultEstimatorTerms: builder.query({
            query: () => ({
                url: `/contractor/estimator_template/default_estimator_terms`,
                method: "GET",
            }),
            providesTags: ["estimatorTemplate"]
          }),

          assignDefaultValuesToTemplate: builder.mutation({
            query: ({id , data}) => {
              return {
                url: `/contractor/estimator_template/${id}/assign_default_values`,
                method: 'PUT',
                body: data,
              };
            },
            invalidatesTags: ['estimatorTemplate'],
          }),

          discardEstimatorTemplate: builder.mutation({ 
            query: ({id }) => {
                return {
                  url: `/contractor/estimator_template/discard/${id}`,
                  method: 'DELETE',
                };
              },
            }),

          deleteBulkItems: builder.mutation({ 
            query: ({ id, ids , type }) => ({
                url: `/contractor/estimator_template/${id}/bulk_delete`,
                method: 'PUT',
                body: { ids ,type },
            })
         })


    })
});
export const {
    useGetAllTemplatesQuery,
    useUpdateTemplateStatusMutation,

    useAddPrimaryServiceMutation,
    useUpdatePrimaryServiceMutation,
    useDeletePrimaryServiceMutation,

    useAddAdditionalServiceMutation,
    useUpdateAdditionalServiceMutation,
    useDeleteAdditionalServiceMutation,

    useAddTermsConditionsMutation,
    useUpdateTermsConditionsMutation,
    useDeleteTermsConditionsMutation

    , useGetEstimatorTemplateByIdQuery,

    useGetAllEstimatorTemplateGeographicAdjustersQuery,

    useUpdateEstimatorTemplateGeographicAdjusterMutation,

    useUpdateEstimatorTemplateGeographicAdjusterToggleMutation,

    useUpdateEstimatorTemplateAdditionalDetailsMutation,

    useRestorePrimaryServicesMutation,

    useRestoreAdditionalServicesMutation,

    useRestoreTermsConditionsMutation,

    useGetSingleEstimatorTemplateQuery,

    useRestoreEstimatorTemplateMutation,

    useSaveEstimatorTemplateMutation,

    useDeleteEstimatorTemplateMutation  ,
    useSetDefaultGeographicAdjusterMutation ,
    useGetDefaultServicesQuery ,
    useGetDefaultAdditionalServicesQuery ,
    useGetDefaultEstimatorTermsQuery,
    useAssignDefaultValuesToTemplateMutation,
    useDiscardEstimatorTemplateMutation ,
    useDeleteBulkItemsMutation
} = estimatorTemplateApi;
